 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"assist-main~classes~community~member~teacher-main":"assist-main~classes~community~member~teacher-main","assist-main~community~teacher-main":"assist-main~community~teacher-main","community":"community","classes~member~periods":"classes~member~periods","integral~member~order":"integral~member~order","assist-main~member~teacher-main":"assist-main~member~teacher-main","member":"member","assist-main~member-exam~teacher-main":"assist-main~member-exam~teacher-main","member-exam":"member-exam","book~classes~common~course~package~periods":"book~classes~common~course~package~periods","book~classes~course":"book~classes~course","classes":"classes","book":"book","periods":"periods","common~course~index~oto":"common~course~index~oto","course":"course","common~oto":"common~oto","common":"common","package":"package","common-component":"common-component","oto":"oto","index":"index","custom-page":"custom-page","download":"download","download-client":"download-client","exam~homework":"exam~homework","exam":"exam","homework":"homework","iframe":"iframe","integral":"integral","order":"order","library":"library","live":"live","login":"login","news":"news","regist-information":"regist-information"}[chunkId]||chunkId) + "." + {"assist-main~classes~community~member~teacher-main":"d05ff472","assist-main~community~teacher-main":"4ec326be","community":"f2ddd968","classes~member~periods":"d3bb3d23","integral~member~order":"5db44c7d","assist-main~member~teacher-main":"30feaa39","member":"4b2f94a5","assist-main~member-exam~teacher-main":"566b04e8","member-exam":"51761193","book~classes~common~course~package~periods":"d523e126","book~classes~course":"f4edac04","classes":"db48c78d","book":"a1c98258","periods":"2039ac0d","common~course~index~oto":"ecfe97ef","course":"47e4af6d","common~oto":"32057755","common":"bb11b367","package":"da94eade","common-component":"cc707d41","oto":"11d4fe5c","index":"81c1d5eb","custom-page":"bd4f12ea","download":"146e0f9d","download-client":"2b1fde71","exam~homework":"21f8e133","exam":"62592296","homework":"56830ab2","iframe":"8dc7b6db","integral":"bbe43a9c","order":"afd6b5a2","library":"c8c871e6","live":"fed57e84","login":"ed2b3588","news":"943bfd86","regist-information":"2d695b1d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"assist-main~classes~community~member~teacher-main":1,"assist-main~community~teacher-main":1,"community":1,"classes~member~periods":1,"integral~member~order":1,"assist-main~member~teacher-main":1,"member":1,"assist-main~member-exam~teacher-main":1,"member-exam":1,"book~classes~common~course~package~periods":1,"book~classes~course":1,"classes":1,"book":1,"periods":1,"common~course~index~oto":1,"course":1,"common~oto":1,"common":1,"package":1,"common-component":1,"oto":1,"index":1,"download":1,"download-client":1,"exam~homework":1,"exam":1,"homework":1,"iframe":1,"integral":1,"order":1,"library":1,"live":1,"login":1,"news":1,"regist-information":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"assist-main~classes~community~member~teacher-main":"assist-main~classes~community~member~teacher-main","assist-main~community~teacher-main":"assist-main~community~teacher-main","community":"community","classes~member~periods":"classes~member~periods","integral~member~order":"integral~member~order","assist-main~member~teacher-main":"assist-main~member~teacher-main","member":"member","assist-main~member-exam~teacher-main":"assist-main~member-exam~teacher-main","member-exam":"member-exam","book~classes~common~course~package~periods":"book~classes~common~course~package~periods","book~classes~course":"book~classes~course","classes":"classes","book":"book","periods":"periods","common~course~index~oto":"common~course~index~oto","course":"course","common~oto":"common~oto","common":"common","package":"package","common-component":"common-component","oto":"oto","index":"index","custom-page":"custom-page","download":"download","download-client":"download-client","exam~homework":"exam~homework","exam":"exam","homework":"homework","iframe":"iframe","integral":"integral","order":"order","library":"library","live":"live","login":"login","news":"news","regist-information":"regist-information"}[chunkId]||chunkId) + "." + {"assist-main~classes~community~member~teacher-main":"79494467","assist-main~community~teacher-main":"4b9e52dc","community":"175dbdfc","classes~member~periods":"1b8f2aa1","integral~member~order":"bc9fde27","assist-main~member~teacher-main":"4e4df6ac","member":"0097e00f","assist-main~member-exam~teacher-main":"c9be347d","member-exam":"c33d3aae","book~classes~common~course~package~periods":"f82a066a","book~classes~course":"1f38dba8","classes":"a7ead73a","book":"870385ea","periods":"a61cb1c4","common~course~index~oto":"71f572e3","course":"3fbd8a5e","common~oto":"11150ef7","common":"14422480","package":"a3e2c39a","common-component":"140b30c0","oto":"8f5909c5","index":"3e5c6517","custom-page":"31d6cfe0","download":"be7e3345","download-client":"960760bf","exam~homework":"b30e7953","exam":"d7ef70f5","homework":"b3fdd1c0","iframe":"4ac96f7a","integral":"88bd4f54","order":"c9c123c9","library":"71fcb01f","live":"ed37b063","login":"1d8c95ff","news":"2b36a84d","regist-information":"08db0536"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.yuaiweiwu.com/fe/prod/bjy-pc-yuaiweiwu/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
